import React, { FC } from "react";

import AddPetButtonAndModal from "../../../components/Pet/AddPetButtonAndModal";
import AddPetTextAndModal from "../../../components/Pet/AddPetTextAndModal";
import { BoldSubHeaderText } from "../../../styles/styledComponents/Header.styled";
import { IPetColorItemResponse } from "../../../services/pet-colors/pet-colors.interface";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { PAGES_PATH } from "../../../navigation/params";
import PetCard from "../../../components/Pet/PetCard";
import { fromUnixToMonthDayStr } from "../../../utils/unix-timestamp";
import { useNavigate } from "react-router-dom";
import { userActivityLogger } from "../../../utils/mixpanel";

interface IPetContainerPet {
  name: string,
  image: string,
  id: string,
  socStatus: string
  lastAppointmentDate?: number
}
interface IPetContainer {
  pets: IPetContainerPet[]
}

const PetContainer: FC<IPetContainer> = (props) => {
  const navigate = useNavigate();

  const OnPetCardClick = (petId: string) => {
    const pet=props.pets.find((data:IPetColorItemResponse)=>data.id==petId);

    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_PET_CARD, { pet_name: pet?.name, referred_from: "Dashboard" });
    navigate(`${PAGES_PATH.PET_CARE}?id=${petId}`);
  };

  return (
    <>
      <div className="flex justify-between">
        <BoldSubHeaderText className="!mb-2">
          My Pets
        </BoldSubHeaderText>
        {props.pets.length > 0 && <AddPetTextAndModal />}
      </div>
      {props.pets.length === 0 &&
      <div className="flex w-100 border border-gray-1 border-dotted p-2">
        <AddPetButtonAndModal />
      </div>}
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6 my-1">
        {/* eslint-disable-next-line */}
        {
          props.pets.map((pet, index) => (
            <PetCard
              petName={pet.name}
              socStatus={pet.socStatus}
              lastVisitDate={pet.lastAppointmentDate ? fromUnixToMonthDayStr(pet.lastAppointmentDate) : "N/A"}
              petImageUrl={pet.image}
              petId={pet.id}
              onClick={OnPetCardClick}
              key={index}
            />
          ))
        }
      </div>
    </>
  );
};

export default PetContainer;
